import { createMemo, createRoot } from 'solid-js'
import type { ArmyPaint } from '../../../lib/core/ArmyPainter/ArmyPaint.type'
import findById from '../../../lib/core/findById'
import type { Nullable } from '../../../typescript'
import { getAuthArmyPaintCollection, setAuthArmyPaintCollection } from './AuthArmyPaintCollectionSignal'

export const getAuthArmyPaint = createRoot(() => {
  const getter = createMemo<Nullable<ArmyPaint>>(() => {
    const { selected, data } = getAuthArmyPaintCollection()
    return findById(data, selected)
  })
  return getter
})

export const setAuthArmyPaint = (ap: Nullable<ArmyPaint>) => {
  const collection = getAuthArmyPaintCollection()
  if (ap) {
    setAuthArmyPaintCollection({
      selected: ap.id,
      data: [...collection.data.filter(row => row.id !== ap.id), ap]
    })
  } else {
    setAuthArmyPaintCollection({
      ...collection,
      selected: null,
    })
  }
}
